import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';

export interface ISeoTag {
  tagType: ISeoTagType;
  i18nKey: string;
  i18nParams?: any;
}
